const pageHomeCheckbox = () => {
  setInterval(() => {
    if (document.querySelector("body.home-page")) {
      const form = document.querySelector(".form-newsletter");
      if (form) {
        if (!document.querySelector(".validating")) {
          // Newsletter Form Validation
          const checkbox = document.getElementById("privacy"),
            checkboxWrapper = document.querySelector(".input-wrapper"),
            nomeField = document.getElementById("nome"),
            cognomeField = document.getElementById("cognome"),
            emailField = document.getElementById("email"),
            submitBtn = document.getElementById("subscribe");
          formValidation(form, checkboxWrapper, checkbox, nomeField, cognomeField, emailField, submitBtn);
        }
        form.classList.add("validating");
      }
    }
  }, 100);
};

export default pageHomeCheckbox;

/**
 * Newsletter Form Validation
 *
 * @param html checkboxWrapper
 * @param html checkbox
 * @param html emailField
 * @param html submitBtn
 *
 */

const formValidation = (form, checkboxWrapper, checkbox, nomeField, cognomeField, emailField, submitBtn) => {
  if (form && checkboxWrapper && checkbox && nomeField && cognomeField && emailField && submitBtn) {
    submitBtn.disabled = true;
    form.addEventListener("change", () => {
      if (checkbox.checked) {
        checkboxWrapper.classList.add("checked");
        if (emailField.value != "" && nomeField.value != "" && cognomeField.value != "") {
          submitBtn.disabled = false;
        }
      } else {
        checkboxWrapper.classList.remove("checked");
        submitBtn.disabled = true;
      }
    });
  } else {
    console.log("Missing params in function formValidation(form, checkboxWrapper, checkbox, nomeField, cognomeField, emailFieldField, submitBtn)", [form, checkboxWrapper, checkbox, nomeField, cognomeField, emailField, submitBtn]);
  }
};
